// src/components/logo/LogoMain.jsx
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import { ThemeMode } from 'config';

import logoLight from 'assets/images/zingo_new.png';
import logoDark from 'assets/images/zingo_new.png';
import { handlerDrawerOpen } from 'api/menu';
export default function LogoMain({ reverse }) {
  const theme = useTheme();
  const isDark = reverse || theme.palette.mode === ThemeMode.DARK;
  const handleClickLogo = () => {
    try {
      handlerDrawerOpen(false);   //  closes the sidebar
    } catch (e) {
      console.error("Could not close drawer:", e);
    }
  };
  return (
    <img
      src={isDark ? logoDark : logoLight}
      alt="Zingo Blast"
       onClick={handleClickLogo} 
      style={{ display: 'flex', alignContent: 'left', justifyContent: 'left',height: 150,width:150,cursor: "pointer" }}
    />
  );
}
LogoMain.propTypes = { reverse: PropTypes.bool };
